import * as React from 'react'
import { Box, Form } from 'cs-kevlar-react'
import { Formik } from 'formik'
import { EditModalActionBar, ConfirmDeleteModal } from 'components'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { EditUserForm, EditUserFormSchema } from './EditUserForm'
import { CustomerUser, EditableUser } from '../../contexts/base'

interface EditUserProps {
  user: CustomerUser
  onClose: () => void
  onDelete: () => void
  onSave: (values: EditableUser) => void
  canViewPermissions: boolean
  canViewCapabilities: boolean
  canViewGlobalConfiguration: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spacer: {
      flexGrow: 1,
      minHeight: 0,
    },
    form: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    formFieldContainer: {
      flexGrow: 1,
      minHeight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  }),
)

export const EditUser: React.FunctionComponent<EditUserProps> = ({
  user,
  onClose,
  onDelete,
  onSave,
  canViewPermissions,
  canViewCapabilities,
  canViewGlobalConfiguration,
}) => {
  const classes = useStyles({})

  const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(
    false,
  )

  const onDeleteClicked = () => {
    setIsConfirmingDelete(false)

    onDelete()
  }

  return (
    <React.Fragment>
      <Formik
        initialValues={user as EditableUser}
        validationSchema={EditUserFormSchema}
        onSubmit={onSave}
      >
        {formikProps => (
          <Form onSubmit={formikProps.handleSubmit} className={classes.form}>
            <Box className={classes.formFieldContainer}>
              <EditUserForm
                formikProps={formikProps}
                canViewPermissions={canViewPermissions}
                canViewCapabilities={canViewCapabilities}
                canViewGlobalConfiguration={canViewGlobalConfiguration}
                allowSearch={false}
              />
            </Box>
            <Box className={classes.spacer} />
            <EditModalActionBar
              onDelete={() => setIsConfirmingDelete(true)}
              onCancel={onClose}
              formikProps={formikProps}
              deleteText="Delete User"
            />
          </Form>
        )}
      </Formik>
      <ConfirmDeleteModal
        onCancel={() => setIsConfirmingDelete(false)}
        onConfirm={onDeleteClicked}
        open={isConfirmingDelete}
        line1Text="Deleting this user will prohibit access to any media items stored within Field Ops by this user.  Please confirm you wish to delete this user.  This action cannot be reversed."
        line2Text={`User: ${user.name}`}
        inputLabelText="Please enter DELETE to confirm deletion of this user."
      />
    </React.Fragment>
  )
}
